import { cn } from '@/lib/utils';

export function BrandFooter({ className }: { className?: string }) {
  return (
    <footer className={cn('text-xs text-[hsl(var(--muted-foreground))]', className)}>
      A product of{' '}
      <a
        href="https://blackitechs.org"
        target="_blank"
        rel="noopener noreferrer"
        className="font-medium text-[hsl(var(--foreground))] underline-offset-4 hover:underline"
      >
        Black I Technologies and Solutions
      </a>
    </footer>
  );
}
